import { parseAlgoliaHitHighlight } from "@algolia/autocomplete-preset-algolia";
import { createElement, Fragment, type JSX } from "react";
import { type HighlightResult } from "algoliasearch";

type AaHighlightParams<THit> = {
	hit: THit;
	attribute: keyof THit | Array<string | number>;
	tagName?: string;
};

export function AaHighlight<THit extends { _highlightResult?: HighlightResult | undefined }>({
	hit,
	attribute,
	tagName = "mark",
}: AaHighlightParams<THit>): JSX.Element {
	return createElement(
		Fragment,
		{},
		parseAlgoliaHitHighlight<THit>({ hit, attribute }).map(({ value, isHighlighted }, index) => {
			if (isHighlighted) {
				return createElement(tagName, { key: index }, value);
			}

			return value;
		})
	);
}
